import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, finalize } from 'rxjs';
import { ApiBridgeService } from 'src/app/api-bridge.service';

@Injectable({
  providedIn: 'root',
})
export class CrowdfundingService implements OnDestroy {
  // private fields
  private unsubscribe: Subscription[] = [];
  isLoading$: Observable<boolean> | undefined;

  constructor(private apiBridgeService: ApiBridgeService) {}

  isLoadingSubject = new BehaviorSubject<boolean>(false);

  getProyectBySeoTag(projectTag: string | undefined): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/projects/${projectTag}`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getAllProjects(params: any): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/projects`;

    return this.apiBridgeService
      .get(endpoint, params)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getAllNews(projectId: number): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/projects/${projectId}/news`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getNewsBySeotag(seotag: string): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/news/${seotag}`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  investInProyect(body: any, seotag: string | undefined): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/auth/projects/${seotag}/invest`;

    return this.apiBridgeService
      .post(endpoint, body)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getFxAndFees(): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `utils/fx_and_fees`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  getCategories() {
    this.isLoadingSubject.next(true);

    const endpoint = `utils/categories`;

    return this.apiBridgeService
      .get(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  setFollow(projectId: string) {
    this.isLoadingSubject.next(true);

    const endpoint = `app/auth/follows/projects/${projectId}`;

    return this.apiBridgeService
      .put(endpoint, {})
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  setUnfollow(projectId: string) {
    this.isLoadingSubject.next(true);

    const endpoint = `app/auth/follows/projects/${projectId}`;

    return this.apiBridgeService
      .delete(endpoint)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  shareProject(seotag: string) {
    return `https://api.incroco.com/utils/share/projects/${seotag}`;
  }

  shareNew(seotag: string) {
    return `https://api.incroco.com/utils/share/news/${seotag}`;
  }

  calculate(projectId: string, params:any): Observable<any> {
    this.isLoadingSubject.next(true);

    const endpoint = `app/projects/${projectId}/calculate`;

    return this.apiBridgeService
      .post(endpoint, params)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
